module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "CN_BOLD"
  }, [_vm._v("Four")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "CIT"
  }, [_c('span', {
    staticClass: "FIRSTLINE_CIT"
  }, [_vm._v("“ZACH!” I CALL OUT THE")]), _vm._v(" next day in the school parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He turns around, and I leave Daisy by the Jeep.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He zips his jacket against the cold as he watches me approach. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I have a favor.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This is new.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("True. Reggie’s the only one I ever ask favors of. “Mind taking Daisy out?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Zach just looks at me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I mean, as a friend. That’s all. She hasn’t gone out since, well, everything, and it would be good for her to be with some friends again.” "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("It would be good for her to not be trailing me.")])])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“Oh. Well, I suppose. But wouldn’t her "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("real")]), _vm._v(" friends be better at this?”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("I glance around the student parking lot at the more-than-inquisitive gazes we’re getting. The gossip surrounding all of us has been ridiculous. “Yes, but she doesn’t want to be with them. She doesn’t feel . . . safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And she’ll feel safe with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, I believe so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He glances over my shoulder to where Daisy is standing and looking at us. “All right. Tell her movie tonight. I’ll pick her up at six.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I haven’t touched him in months, so when I reach out and grasp his arm, it takes us both by surprise. So much surprise I lose what I want to say.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His dark eyes hold steady to mine as he waits. But when I don’t say anything, he quietly prompts, “Lane?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I blink and let go and take a step back. "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("Get ahold of yourself, Lane.")]), _vm._v(" “Thanks, Zach. This means a lot to me. You taking Daisy out,” I clarify.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He nods, and I ignore the urge to touch him again as I turn and walk back to Daisy. But as I walk, I have the distinct sensation he’s still standing there, watching "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("over")]), _vm._v(" me. Warmth settles through me at just the thought. "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("Over")]), _vm._v(" me. That comforts me more than it should. And confuses me. I’ve never needed anybody watching over me.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("To my surprise, Daisy doesn’t fight it when I get back into the Jeep. ")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Zach.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yep,” I say as I crank the engine and heater. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What about Dad and dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He’ll be fine.” Actually, he’ll probably be relieved. He could use a break. “Zach said he’d pick you up tonight at six.” At 6:01 I’ll be out the door and heading to Aisha. She and I are going to have a little talk.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We get Justin, head home, and do the usual snack/homework thing. At five minutes before six Zach rings our doorbell.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Justin answers. “Hi!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Zach fist-bumps him. “Hey, little man. Daisy ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Daisy,” Justin calls upstairs as Zach steps into our house.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The last time he was here, we were alone and having sex. Seems like an eternity ago now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He turns and catches sight of me on my laptop at the dining room table. “Hey, you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The warmth from earlier creeps back in, and my lips automatically curl up in response. I do love how he greets me. “Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Daisy comes down the stairs dressed in jeans, a sweater, and boots. She’s let her blond hair go naturally wavy and wears just a bit of makeup. I like the new Daisy. Not fake anymore. It’s perplexing to me how tragedy changes people. She’s becoming the sister I always wished I had. Minus the two peas thing.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("I, however, have turned into an unfocused mess. But, hopefully, that will change tonight. With Aisha.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“You look nice,” I honestly tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She grins—“Thanks”—and turns to Zach. “Ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I was thinking Justin might want to come too?” Zach suggests.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Justin gives an excited little hop. “Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Daisy takes one look at him and immediately softens. “Sure. Go ask Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Wow, my sister really has changed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Justin bolts into the office and seconds later comes back out. “He said yes!” He grabs his coat and they’re all out the door. I don’t get one last look from Zach and find myself disappointed with this.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I duck my head in the office. “Did you bring that stuff home of Mom’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, not yet.” He glances up from his file. “Hey, with your brother and sister both gone, mind if we just fend for ourselves tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I smile. I knew he needed a break. “No problem. Can I do my usual coffee shop thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sure, but why didn’t you go with Zach too?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s not like him to question me, and it takes me off guard. “Big paper due tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He nods. “All right.”")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“I’ll be back by curfew,” I tell him.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("By six fifteen I’m in my Jeep and heading to Aisha’s apartment in Alexandria. Her community is three-story, brick, and clean.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There are a lot of kids out in the common area playing, laughing, and I wonder if she has sold to any of them. Has approached any of them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A couple walks by, pushing a baby stroller and shooting me a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("An older gentleman comes out of his apartment to check the mail.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Someone on the first floor opens a window, and I catch the faint sound of a kitchen smoke alarm beeping.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Seems like such a family-friendly complex for a drug dealer to live in.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Slowly I pull past the landing that leads to her second-story apartment, and Aisha walks right down the stairs. Perfect timing. She’s dressed in all black and doesn’t look up as she climbs into a dark car, backs up, and drives right past me out of the complex.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I do a U-turn and begin following at a safe distance.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She doesn’t go far, pulling into a Starbucks. I park farther down the block and watch as she jumps out. Her dark hair is pulled back into a tight ponytail, like it was in Penn’s court, and she wears tiny black-framed glasses.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Carrying an iPad, she pays a meter and goes inside the café.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("If she did see me in the alley with Jacks, she wouldn’t recognize me. I had my full-face mask on. So I don’t worry as I cut my engine, wrap a scarf around my neck, and “talk” into my cell phone as I walk toward the Starbucks. To any onlooker I’m just another teen out for a caffeine fix and certainly not following someone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Aisha’s over in the corner, nibbling on a pastry and sliding her finger over her iPad. I take my place in line, and when it’s my turn, I get my usual. Grande dark roast with room for milk.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At the cream stand I top it off with milk and, blowing on it, wander over to the magazine rack. I choose one with Kate Middleton on the front and pick a spot far enough away from Aisha but from which I can watch her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I open my magazine and pretend to browse, all the while watching her study her iPad. I’ve already seen her in action selling to kids, but after Jacks being beaten, I want more of a sense of her and if she’s capable of that type of violence. I take in her dark jeans and hoodie again. She’s not as tall as me, but add a mask and she could easily be mistaken for the Masked Savior.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("From my research I know she’s younger than Jacks. Only nineteen. She got kicked out of her home and has been living with a friend for a few months. As nonthreatening as she looks ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("with her glasses and ponytail, she’s actually ideal for introducing young kids to drugs.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("I take a final sip of coffee, close my magazine, glance one last time in her direction, and see her staring right at me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pause. There’s no way she knows who I am.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She doesn’t smile, just stares at me, and it sends a very distinct shiver of awareness across my neck. She’s malicious. Of this I’m sure. If there’s one thing I’ve developed, it’s an intuition when it comes to evil, and Aisha just officially put mine on full alert.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yes, she’s capable of impersonating me and beating up Jacks. I’m sure of it.")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-945d7ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch04.vue
// module id = 72
// module chunks = 0